import { createTheme } from "@mui/material";

export const breakpointValues = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1280,
  collapseContextDrawer: 1774,
  collapseNavDrawer: 1374,
};

export const customBreakpoints = createTheme({
  breakpoints: {
    values: {
      xs: breakpointValues.xs,
      sm: breakpointValues.sm,
      md: breakpointValues.md,
      lg: breakpointValues.lg,
      xl: breakpointValues.xl,
      collapseContextDrawer: breakpointValues.collapseContextDrawer,
      collapseNavDrawer: breakpointValues.collapseNavDrawer,
    },
  },
}).breakpoints;
